const keys = {
  all: ['integrations'],
  procoreOauthCallback: (pinsCompanyId, procoreCompanyId, code) => [...keys.all, 'companies', { companyId: pinsCompanyId, procoreCompanyId }, 'oauth', { code }],
  procoreProject: (companyId, procoreProjectId) => [...keys.all, 'companies', { companyId }, 'procore_projects', { procoreProjectId }],
  procoreProjectRecords: (companyId, procoreProjectId, search) => [...keys.all, 'companies', { companyId }, 'procore_projects', { procoreProjectId }, 'records', { search }],
  procoreProjectRecordsExcel: (companyId, procoreProjectId, search) => [...keys.procoreProjectRecords(companyId, procoreProjectId, search), 'reports']
};

export default keys;
